<template>
  <div class="gf-clone-project">
    <gf-dropdown
      class="gf-clone-project__dropdown"
      position="right"
      btn-icon="gf-icon gf-icon-download mr-2"
      btn-class="btn btn-sm btn-success w-100"
      btn-text="Код"
      style="--gfd-minw: min(calc(100vw - 4rem), 350px); display: none"
      ref="cloneProjectDropdown"
    >
      <div class="p-2">
        <div
          v-if="renderGitTabs"
          class="font-weight-bolder mb-2"
        >
          <i
            class="gf-icon gf-icon-terminal mr-2"
            style="margin-bottom: 1px"
          ></i>
          {{ $t('message.clone') }}
        </div>
        <gf-custom-tabs v-if="renderGitTabs">
          <template #links>
            <ul class="d-flex code-tab-line-nav nav nav-tabs gap-3">
              <li class="px-0 pb-1">
                <a
                  href="#https"
                  class="gf-tabs__links-item"
                  :class="{ active: !hasSSH }"
                >
                  HTTPS
                </a>
              </li>
              <li class="px-0 pb-1">
                <a
                  href="#ssh"
                  class="gf-tabs__links-item"
                  :class="{ active: hasSSH }"
                >
                  SSH
                </a>
              </li>
            </ul>
          </template>
          <template #tabs>
            <div
              id="https"
              class="gf-tabs__tabs-item"
              :class="{ active: !hasSSH }"
            >
              <gf-custom-clipboard
                class="my-2 w-100"
                :text-to-copy="httpTransportUrl"
              ></gf-custom-clipboard>
            </div>
            <div
              id="ssh"
              class="gf-tabs__tabs-item"
              :class="{ active: hasSSH }"
            >
              <gf-custom-clipboard
                class="my-2 w-100"
                :text-to-copy="sshTransportUrl"
              ></gf-custom-clipboard>
            </div>
          </template>
        </gf-custom-tabs>
        <div v-if="renderDownloadButton && isFileDownload">
          <div class="mt-3 mb-2">
            <small class="text-muted">Расширение архива проекта</small>
            <div
              class="gf-segment-control w-100"
              data-number="6"
            >
              <input
                type="radio"
                id="projectArchiveFormat-zip"
                name="projectArchiveFormat"
                value="zip"
                v-model="format"
              />
              <label for="projectArchiveFormat-zip">zip</label>

              <input
                type="radio"
                id="projectArchiveFormat-tar"
                name="projectArchiveFormat"
                value="tar"
                v-model="format"
              />
              <label for="projectArchiveFormat-tar">tar</label>

              <input
                type="radio"
                id="projectArchiveFormat-tar-gz"
                name="projectArchiveFormat"
                value="tar.gz"
                v-model="format"
              />
              <label for="projectArchiveFormat-tar-gz">tar.gz</label>

              <input
                type="radio"
                id="projectArchiveFormat-tar-bz2"
                name="projectArchiveFormat"
                value="tar.bz2"
                v-model="format"
              />
              <label for="projectArchiveFormat-tar-bz2">tar.bz2</label>

              <input
                type="radio"
                id="projectArchiveFormat-tar-xz"
                name="projectArchiveFormat"
                value="tar.xz"
                v-model="format"
              />
              <label for="projectArchiveFormat-tar-xz">tar.xz</label>

              <input
                type="radio"
                id="projectArchiveFormat-7z"
                name="projectArchiveFormat"
                value="7z"
                v-model="format"
              />
              <label for="projectArchiveFormat-7z">7z</label>
            </div>
          </div>
          <a
            class="btn btn-outline-success btn-sm btn-block justify-content-center"
            :href="`/project/${alias}/${projectAlias}/file/downloadAll?branch=${currentBranch}&format=${format}`"
            @click="onDownloadLinkClick"
          >
            <i class="gf-icon gf-icon-download-alt mr-1"></i>
            {{ $t('message.download') }}
          </a>
        </div>
        <div v-else-if="userInfo?.length > 0 || isPullEnabled">
          <div
            v-if="renderGitTabs"
            class="border-top mb-1"
          ></div>
          <a
            class="link-primary small"
            href="/auth/login"
          >
            {{ $t('message.login_to_download') }}
          </a>
        </div>
      </div>
    </gf-dropdown>
  </div>
</template>

<script>
import GfDropdown from '@/shared-modules/shared-components/shared/GfDropdown';
import GfCustomTabs from '@shared/shared-components/shared/GfCustomTabs';
import GfCustomClipboard from '@/shared-modules/shared-components/shared/GfCustomClipboard';

export default {
  name: 'GfCloneProjectDropdown',
  components: { GfDropdown, GfCustomTabs, GfCustomClipboard },
  props: {
    alias: {
      type: String,
      default: ''
    },
    projectAlias: {
      type: String,
      default: ''
    },
    currentBranch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      renderGitTabs: false,
      renderDownloadButton: false,
      isFileDownload: false,
      isPullEnabled: false,
      hasSSH: false,
      httpTransportUrl: '',
      sshTransportUrl: '',
      userInfo: null,
      format: 'zip'
    };
  },
  mounted() {
    this.renderGitTabs = document.getElementById('renderGitTabs')?.value === 'true';
    this.renderDownloadButton = document.getElementById('renderDownloadButton')?.value === 'true';
    this.isFileDownload = document.getElementById('isFileDownload')?.value === 'true';
    this.isPullEnabled = document.getElementById('isPullEnabled')?.value === 'true';
    this.hasSSH = document.getElementById('hasSSH')?.value === 'true';
    this.httpTransportUrl = document.getElementById('httpTransportUrl')?.value;
    this.sshTransportUrl = document.getElementById('sshTransportUrl')?.value;
    this.userInfo = document.getElementById('userInfo')?.value;
  },
  methods: {
    onDownloadLinkClick() {
      this.$refs.cloneProjectDropdown.close();
    }
  }
};
</script>
